import { createActionsHook, createHook, createStore } from 'react-sweet-state';

type State = {
	isWebSearchAllowedByAdmin: boolean;
};

const initialState: State = {
	isWebSearchAllowedByAdmin: false,
};

export const store = createStore({
	name: 'webSearchConfigStore',
	initialState,
	actions: {
		setWebSearchAllowedByAdmin:
			(isAllowed: boolean) =>
			({ setState }) => {
				setState({ isWebSearchAllowedByAdmin: isAllowed });
			},
	},
});

export const useWebSearchConfigStore = createHook(store);
export const useWebSearchConfigStoreActions = createActionsHook(store);

// Helper function to get the current state value (for use outside of hooks/actions)
// Access the store's internal state
export const getWebSearchAllowedByAdmin = (): boolean => {
	// @ts-expect-error - store.storeState is an internal API
	return store.storeState?.getState()?.isWebSearchAllowedByAdmin ?? false;
};
